// extracted by mini-css-extract-plugin
export var formContainer = "_jp-0";
export var message = "_jp-1";